import { Card } from "@/components/ui/card";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Star } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { resolveImg } from "@/lib/api";

export const Testimonials = ({ testimonials = {} }) => {
  const items = testimonials.items || [];
  return (
    <section id="testimonials" className="scroll-anchor relative overflow-hidden bg-background">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(900px_circle_at_10%_20%,hsl(36_35%_93%)_0%,transparent_55%)]" />
      <div className="relative mx-auto max-w-6xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
        <Reveal>
          <div className="max-w-2xl">
            <p className="text-sm font-semibold uppercase tracking-wider text-accent">{testimonials.eyebrow}</p>
            <h2 className="font-display mt-2 text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">{testimonials.heading}</h2>
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
          {items.map((t, i) => (
            <Reveal key={t.name || i} delay={i * 0.08}>
              <Card className="h-full rounded-xl border-border bg-card p-6 shadow-[0_10px_30px_-18px_rgba(15,23,42,0.25)] transition-shadow duration-200 hover:shadow-[0_18px_50px_-26px_rgba(15,23,42,0.35)]">
                <div className="flex gap-0.5 text-accent">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <Star key={s} className="h-4 w-4 fill-current" />
                  ))}
                </div>
                <p className="mt-4 text-sm leading-relaxed text-foreground/85">“{t.quote}”</p>
                <div className="mt-6 flex items-center gap-3">
                  <Avatar className="h-10 w-10">
                    <AvatarImage src={resolveImg(t.avatar)} alt={t.name} />
                    <AvatarFallback>{(t.name || "E").split(" ").map((n) => n[0]).join("")}</AvatarFallback>
                  </Avatar>
                  <div>
                    <p className="text-sm font-semibold text-foreground">{t.name}</p>
                    <p className="text-xs text-muted-foreground">{t.role}</p>
                  </div>
                </div>
              </Card>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
